import React from "react";
import PropTypes from "prop-types";

const FlagLoader = ({ size = 28, color = "#17c1e8" }) => {
  const borderWidth = Math.max(2, Math.round(size / 10));

  return (
    <span
      role="status"
      aria-label="Loading"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        verticalAlign: "middle",
      }}
    >
      <span
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          border: `${borderWidth}px solid rgba(23, 193, 232, 0.18)`,
          borderTopColor: color,
          animation: "questLoaderSpin 0.65s linear infinite",
          boxSizing: "border-box",
        }}
      />
      <style>{`
        @keyframes questLoaderSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </span>
  );
};

FlagLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default FlagLoader;
